import React from "react";
import { Typography } from "@material-ui/core";
import styles from "../styles";

function TitleIXContactBox() {
  const useStyles = styles;
  const classes = useStyles();

  return (
    <div style={{ flex: window.innerWidth >= 640 ? "0 0 45%" : "1 1 100%", minWidth: "250px" }}>
      <Typography className={classes.justBold}>
        Title IX Office
      </Typography>
      <Typography style={{ wordBreak: "break-word" }}>
        Email: <a href="mailto:Title.IXUOP@phoenix.edu" style={{ color: "inherit", textDecoration: "underline" }}>Title.IXUOP@phoenix.edu</a>
      </Typography>
      <Typography>
        Phone: (602) 557-6176
      </Typography>
    </div>
  );
}

export default TitleIXContactBox;
